export function convertCurrentTimeToPSTFormat(): string {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })
    .format(new Date())
    .replace(/\//g, '-');
}
